export default class NatureOperation {
    constructor() {
        this.id = "";
        this.name = "";
    }
    update(data) {
        this.id = data.id;
        this.name = data.name;
    }
}